import { TenantConfig } from './types/TenantConfig'
import logo from '@app/assets/fullLogo.svg'

const crowdbuildingTenantConfig: TenantConfig = {
  title: 'CrowdBuilding',
  domain: 'crowdbuilding.com',
  logoUrl: logo,

  email: 'info@crowdbuilding.com',
}

export default crowdbuildingTenantConfig
